import Default from "layouts/auth/types/Default";
import React from "react";
import PinInput from "react-pin-input";
import { Link } from "react-router-dom";

function VerificationDefault() {
  return (
    <Default
      back="/auth/signin"
      maincard={
        <div className="w-full max-w-full flex-col items-center px-4 md:w-[420px]">
          <h2 className="mt-1 text-4xl font-bold text-navy-700 dark:text-white">
            2-Step Verification
          </h2>
          <p className="mt-[15px] ml-1 text-[15px] text-gray-600">
            Please enter the code we’ve sent you to your email
          </p>
          {/* verification */}
          <div className="mt-7 mb-4 flex w-full items-center justify-center">
            <PinInput
              length={4}
              initialValue=""
              onChange={(value, index) => {}}
              type="numeric"
              inputMode="number"
              style={{ marginBottom: "10px" }}
              inputStyle={{
                borderWidth: "2px",
                width: "80px",
                height: "80px",
                borderColor: "#E0E5F2",
                borderRadius: "16px",
                color: "#2B3674",
                fontSize: "36px",
                margin: "0 7px"
              }}
              inputFocusStyle={{ borderColor: "#4318FF", borderWidth: "3px" }}
              onComplete={(value, index) => {}}
              autoSelect={true}
              regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
            />
          </div>
          {/* button */}
          <button className="h-[50px] w-full rounded-xl bg-brand-500 text-base font-medium text-white transition duration-200 hover:bg-brand-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
            Confirm
          </button>
          <p className="mt-4 text-sm font-medium text-navy-700 dark:text-gray-500">
            Haven't received it?
            <Link className="text-sm font-medium text-brand-500 dark:text-white">
              {" "}
              Resend a new code{" "}
            </Link>
          </p>
        </div>
      }
    />
  );
}

export default VerificationDefault;
